import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class UsuarioForm extends Component {
  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      nombre: ['required'],
      email: ['required', 'email'],
      password: !this.props.data.id ? ['required', 'string', 'min:8', 'max:150'] : []
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValid: validator.passes()
    });
  }

  componentWillUnmount() {
    this.props.onChangeInfo();
  }

  render() {
    const { data = {} } = this.props;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Nombre"
          name="nombre"
          placeholder=""
          help=""
          rules={ this.rules.nombre }
          value={ data.nombre }
          onChange={ this.handleOnChange }
        />

        { !data.id && (
          <FormControl type="text"
            label="Email"
            name="email"
            placeholder="email@example.com"
            help=""
            rules={ this.rules.email }
            value={ data.email }
            onChange={ this.handleOnChange }
          />
        )}

        <FormControl type="password"
          label="Contraseña"
          name="password"
          placeholder=""
          help="Llenar campo solo si desea modificar la contraseña."
          rules={ this.rules.password }
          value={ data.password }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default UsuarioForm;